/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/no-useless-constructor */
/* eslint-disable  @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-extraneous-class */
/* eslint-disable @typescript-eslint/no-empty-object-type */
import { z } from 'zod';
import { validate } from '../../error/validate';
import { enumSchema, domainWsIntervalTypeSchema, type DomainWsIntervalType, localDatetimeSchema, type DomainWsVariantObject, type DomainWsVariantAvailability, type DomainJsonObject, type DomainWspdclasttrans, type DomainWscommitid, } from '../../schema';
import { type WebResponseResult, ValidationError } from '@pdcfrontendui/staffplan';
import { WebRequest } from './WebRequest';
import {
  WebTypeViewField,
  WebField,
  WebRecord,
  WebList,
  WebElement,
  LogonSettings,
  WebSortConfig,
  WebFieldConfig,
  WebListConfig,
  WebRecordType,
  WsRefPerson,
  WsRefOrgunit,
  WsRefOrgunitByInfo,
  WsRefShiftCounter,
  WsRefShifttype,
  WsRefTaskDef,
  WsRefTask,
  WsRefAccount,
  WsRefProject,
  WsRefDimensionItem,
  globalSettingsSchema,
  webElementSchema,
  webFieldConfigSchema,
  webFieldSchema,
  webListConfigSchema,
  webListSchema,
  webRecordSchema,
  webRecordTypeSchema,
  webSortConfigSchema,
  webTypeViewFieldSchema,
  wsRefAccountByNameSchema,
  wsRefAccountSchema,
  wsRefDimensionItemByNameSchema,
  wsRefDimensionItemSchema,
  wsRefOrgunitByInfoSchema,
  wsRefOrgunitSchema,
  wsRefPersonByAuxSchema,
  wsRefPersonByNameSchema,
  wsRefPersonBySalaryIdSchema,
  wsRefPersonSchema,
  wsRefProjectByNameSchema,
  wsRefProjectSchema,
  wsRefShiftCounterSchema,
  wsRefShiftDefByExternalIdSchema,
  wsRefShiftDefByIdSchema,
  wsRefShiftDefByNameSchema,
  wsRefShiftDefSchema,
  wsRefShiftTypeByExternalIdSchema,
  wsRefShiftTypeByNameSchema,
  wsRefShifttypeSchema,
  wsRefTaskByExternalIdSchema,
  wsRefTaskByNameSchema,
  wsRefTaskDefByExternalIdSchema,
  wsRefTaskDefByNameSchema,
  wsRefTaskDefSchema,
  wsRefTaskSchema,
  globalSettingsJsonSchema,
  webElementJsonSchema,
  webFieldConfigJsonSchema,
  webFieldJsonSchema,
  webListConfigJsonSchema,
  webListJsonSchema,
  webRecordJsonSchema,
  webRecordTypeJsonSchema,
  webSortConfigJsonSchema,
  webTypeViewFieldJsonSchema,
  wsRefAccountByNameJsonSchema,
  wsRefAccountJsonSchema,
  wsRefDimensionItemByNameJsonSchema,
  wsRefDimensionItemJsonSchema,
  wsRefOrgunitByInfoJsonSchema,
  wsRefOrgunitJsonSchema,
  wsRefPersonByAuxJsonSchema,
  wsRefPersonByNameJsonSchema,
  wsRefPersonBySalaryIdJsonSchema,
  wsRefPersonJsonSchema,
  wsRefProjectByNameJsonSchema,
  wsRefProjectJsonSchema,
  wsRefShiftCounterJsonSchema,
  wsRefShiftDefByExternalIdJsonSchema,
  wsRefShiftDefByIdJsonSchema,
  wsRefShiftDefByNameJsonSchema,
  wsRefShiftDefJsonSchema,
  wsRefShiftTypeByExternalIdJsonSchema,
  wsRefShiftTypeByNameJsonSchema,
  wsRefShifttypeJsonSchema,
  wsRefTaskByExternalIdJsonSchema,
  wsRefTaskByNameJsonSchema,
  wsRefTaskDefByExternalIdJsonSchema,
  wsRefTaskDefByNameJsonSchema,
  wsRefTaskDefJsonSchema,
  wsRefTaskJsonSchema,
} from './Common_api';
import { PlanEnum, AttendanceClockInOutEnum, TimeAttendanceDeviationEnum, WsAttendanceQueryTypeEnum, TimeAttendanceRefTypeEnum, WsTimeRegEventTypeEnum, ApplicationTypeEnum, PlanSchema, AttendanceClockInOutSchema, TimeAttendanceDeviationSchema, WsAttendanceQueryTypeSchema, TimeAttendanceRefTypeSchema, WsTimeRegEventTypeSchema, ApplicationTypeSchema, PlanJsonSchema, AttendanceClockInOutJsonSchema, TimeAttendanceDeviationJsonSchema, WsAttendanceQueryTypeJsonSchema, TimeAttendanceRefTypeJsonSchema, WsTimeRegEventTypeJsonSchema, ApplicationTypeJsonSchema } from './enumLib_api';
export const viewportSchema = z.object({
	width: z.int(),
	height: z.int()
});

export const viewportJsonSchema = z.object({
	width: z.int(),
	height: z.int()
});

/** Responsible: ASHA, Updated: 20190110 */
export class Viewport {
	constructor(
		public width: number,
		public height: number,
	) {}
}

export const trackingActivitySchema = z.object({
	name: z.string(),
	timeStamp: z.coerce.date(),
	auxDate: z.coerce.date().optional().nullable().default(null)
});

export const trackingActivityJsonSchema = z.object({
	name: z.string(),
	timeStamp: z.iso.datetime({ local: true }),
	auxDate: z.iso.datetime({ local: true }).optional().nullable().default(null)
});

/** Responsible: ASHA, Updated: 20190110 */
export class TrackingActivity {
	constructor(
		public name: string,
		public timeStamp: Date,
		public auxDate: Date | null = null,
	) {}
}

export const navigationSchema = z.object({
	viewName: z.string(),
	timeStamp: z.coerce.date(),
	activities: z.array(z.lazy(() => trackingActivitySchema))
});

export const navigationJsonSchema = z.object({
	viewName: z.string(),
	timeStamp: z.iso.datetime({ local: true }),
	activities: z.array(z.lazy(() => trackingActivityJsonSchema))
});

/** Responsible: ASHA, Updated: 20190110 */
export class Navigation {
	constructor(
		public viewName: string,
		public timeStamp: Date,
		public activities: TrackingActivity[],
	) {}
}

export const trackingObjectSchema = z.object({
	userHash: z.string(),
	sessionStart: z.coerce.date(),
	viewPort: z.lazy(() => viewportSchema),
	device: z.string(),
	navigations: z.array(z.lazy(() => navigationSchema)),
	version: z.string(),
	applicationType: ApplicationTypeSchema,
	hasBiometricAuth: z.boolean(),
	hasCalendarLink: z.boolean(),
	hasCalendarImport: z.boolean(),
	hasPreferencePattern: z.boolean()
});

export const trackingObjectJsonSchema = z.object({
	userHash: z.string(),
	sessionStart: z.iso.datetime({ local: true }),
	viewPort: z.lazy(() => viewportJsonSchema),
	device: z.string(),
	navigations: z.array(z.lazy(() => navigationJsonSchema)),
	version: z.string().describe("Application version"),
	applicationType: ApplicationTypeJsonSchema.describe("Is the user using the app or a browser"),
	hasBiometricAuth: z.boolean().describe("Has the user enabled biometric authentication"),
	hasCalendarLink: z.boolean().describe("Does the user have an active calendar export link"),
	hasCalendarImport: z.boolean().describe("Has the user enabled import of a personal calendar"),
	hasPreferencePattern: z.boolean().describe("Has the user defined a preference pattern")
});

/** Responsible: AGRU, Updated: 20250210 */
export class TrackingObject {
	constructor(
		public userHash: string,
		public sessionStart: Date,
		public viewPort: Viewport,
		public device: string,
		public navigations: Navigation[],
		/** Application version */
		public version: string,
		/** Is the user using the app or a browser */
		public applicationType: ApplicationTypeEnum,
		/** Has the user enabled biometric authentication */
		public hasBiometricAuth: boolean,
		/** Does the user have an active calendar export link */
		public hasCalendarLink: boolean,
		/** Has the user enabled import of a personal calendar */
		public hasCalendarImport: boolean,
		/** Has the user defined a preference pattern */
		public hasPreferencePattern: boolean,
	) {}
}

/** Responsible: ASHA, Updated: 20190110 */
export class ReportTracking extends WebRequest<boolean> {
	public readonly webService = "tracking";
	public readonly method = "ReportTracking";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public tracking: TrackingObject,
	) {
		super();
	}

	public static readonly create = (x: {tracking: TrackingObject}): ReportTracking => {
        return new ReportTracking(x.tracking);
          }
	public static readonly returnSchema = z.boolean();
	public resultFromJSON(json: WebResponseResult<boolean>): boolean {
		return validate(ReportTracking.returnSchema, json) as unknown as boolean;
	}
}

export const ReportTrackingAI = { key: 'tracking_ReportTracking' as const,
          webService: 'tracking' as const,
           method: 'ReportTracking' as const,
           description: "",
           inputJsonSchema: z.object({ tracking: z.lazy(() => trackingObjectJsonSchema)}),
           inputSchema: z.object({ tracking: z.lazy(() => trackingObjectSchema)}),
          outputJsonSchema: z.boolean(),
          outputSchema: z.boolean(),
          requestClass: ReportTracking
          }
export const endpoints = [ReportTrackingAI] as const;
export type Endpoint = (typeof endpoints)[number];
